@if(true){
<div id="ModalPopUP" class="modal fade" role="dialog">
    <div class="modal-dialog-FactSheet">
        <div class="modal-content">
            <div class="modal-header BlueHeader">
                <h4 class="Heading"> {{ModelFor}}</h4><br>
                <button type="button" id="close" class="close" (click)="this[CallFunctionOnCloseModal]()"
                    data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body  col-sm-12 form-group">
                <iframe width="100%" Height="500px" [src]="modalURL|safe"></iframe>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid">
    <div class="table-header-container">
        <div class="table-heading">
            View Diary/Plan
        </div>
        <form #SearchPlanDiary="ngForm" [formGroup]="FormSearchPlanDiary"
            (ngSubmit)="onSearchPlanDiary(SearchPlanDiary.value)">
            <div class="d-flex">
                <div class="input-group">
                    <input type="text" placeholder="Search here" class="table-search-input form-control"
                        formControlName="txtSearch">
                    <span class="input-group-btn">
                        <button class="btn btn-primary" title="Search" type="submit">
                            Go
                        </button>
                    </span>
                </div>
                @if (this.RightsID.includes('202024001') || this.RightsID.includes('202024021')) {
                <button class="btn btn-outline-primary mx-2" title="Add Diary" data-toggle="modal"
                    (click)="OpenModal('ndc','0','Add Diary','ReturnAdvanceSearch')" data-target="#ModalPopUP">
                    <i class="fas fa-plus"></i>
                </button>
                } @else {
                <button class="btn btn-outline-primary mx-2" title="Add Diary" routerLink="/module/0">
                    <i class="fas fa-plus"></i>
                </button>
                }
                <button class="btn btn-outline-primary" title="Advance Search" data-toggle="modal"
                    (click)="OpenModal('ndc','0','Filter','ReturnAdvanceSearch')" data-target="#ModalPopUP">
                    <i class="fas fa-filter"></i>
                </button>
            </div>
        </form>
    </div>
    <div class="card table-container">
        <table class="custom-table">
            <thead>
                <tr>
                    <th>Sr. No.</th>
                    <th>Date</th>
                    <th>In Time</th>
                    <th>Ref No.</th>
                    <th>Last Follow up</th>
                    <th>Plan of Action</th>
                    <th>Action Type</th>
                    <th>Entry For</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <app-table-state [loading]="MsgType == 1" [error]="MsgType == 3 ? DisplayMessage : null"
                    [empty]="filteredData?.length == 0" [rows]="10" [columns]="9">
                </app-table-state>
                @if (filteredData?.length > 0) {
                    @for (diary of filteredData | paginate : { itemsPerPage: pageSize, currentPage: pageNumber }; track diary.id ?? i ;
                    let i = $index) {
                    <tr>
                        <td align="center">{{ (pageNumber - 1) * 10 + i + 1 }}</td>
                        <td>{{ diary.PlanDate | date: "dd-MMM-yyyy" }}</td>
                        <td>{{ diary.PlanInTime }}</td>
                        <td>
                            @if (diary.refno != null) {
                            <a target="_blank" routerLink="/gnotice/{{ diary.NoticeType }}/{{ diary.NoticeID }}">{{
                                diary.refno }}</a>
                            } @else if (diary.NoticePlanningID != null) {
                            <a target="_blank" routerLink="/corporate-decision/{{ diary.NoticePlanningID }}">Decision No -
                                {{ diary.NoticePlanningID }}</a>
                            } @else {
                            &nbsp;
                            }
                        </td>
                        <td>{{ diary.FUDescr }}</td>
                        <td>{{ diary.PlanDescr }}</td>
                        <td>{{ diary.planType }}</td>
                        <td>{{ diary.UserName }}</td>
                        <td>
                            @if (diary.FollowUpID != '0') {
                            Done
                            } @else if (diary.NoticeType == 'case') {
                            <a href="udc/{{ diary.NoticeID }}/{{ diary.ID }}/2"
                                class="icon-btn icon-btn-primary text-decoration-none">
                                <i class="fa fa-pencil" aria-hidden="true"></i>
                            </a>
                            } @else if (diary.NoticeType == 'notice') {
                            <a href="udc/{{ diary.NoticeID }}/{{ diary.ID }}/0"
                                class="icon-btn icon-btn-primary text-decoration-none">
                                <i class="fa fa-pencil" aria-hidden="true"></i>
                            </a>
                            } @else if (diary.refno == null && diary.NoticePlanningID == null) {
                            <a href="udc/0/{{ diary.ID }}/4" class="icon-btn icon-btn-primary text-decoration-none">
                                <i class="fa fa-pencil" aria-hidden="true"></i>
                            </a>
                            } @else if (diary.refno == null && diary.NoticePlanningID != null) {
                            <a href="udc/{{ diary.NoticePlanningID }}/{{ diary.ID }}/1"
                                class="icon-btn icon-btn-primary text-decoration-none">
                                <i class="fa fa-pencil" aria-hidden="true"></i>
                            </a>
                            }
                        </td>
                    </tr>
                    }
                }
            </tbody>
        </table>
    </div>
    @if (MsgType == 0 && filteredData?.length > 0) {
              <div class="d-flex justify-content-between my-3 w-100">
          <div class="w-50">
            <app-rows-per-page
            [pageSize]="pageSize"
            [total]="totalRecords"
            [pageIndex]="pageNumber"
            (pageSizeChange)="onPageSizeChange($event)">
          </app-rows-per-page>
          </div>
        <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
      </div>
    }
</div>
}@else {
<!-- <my-content placeholder="navigation">

    <div class="col-sm-12 " style="border-bottom: 1px solid #ccc;"></div>
    <div id="ModalPopUP" class="modal fade" role="dialog">
        <div class="modal-dialog-FactSheet">
            <div class="modal-content">
                <div class="modal-header BlueHeader">
                    <h4 class="Heading"> {{ModelFor}}</h4><br>
                    <button type="button" id="close" class="close" (click)="this[CallFunctionOnCloseModal]()"
                        data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body  col-sm-12 form-group">
                    <iframe width="100%" Height="390 px" [src]="modalURL|safe"></iframe>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-12" style="margin-top: 8px;">
        <div class="col-sm-12"
            style="background-color: #eee; border:1px solid #ddd;padding-top:10px; padding-bottom: 10px;">
            <div class="col-sm-4">
                <form #SearchPlanDiary="ngForm" [formGroup]="FormSearchPlanDiary"
                    (ngSubmit)="onSearchPlanDiary(SearchPlanDiary.value);">
                    <div class="col-sm-2 height-34">Search</div>
                    <div class="col-sm-6"><input class="form-control" formControlName="txtSearch"
                            placeholder="Search here" name="txtSearch" type="text" value=""></div>
                    <div class="col-sm-2"><input class="btn btn-primary btn-sm-12" type="submit" value="Go"></div>
                    <div class="col-sm-2"> <a title="Advance Search" data-toggle="modal"
                            (click)="OpenModal('ndc','0','Filter','ReturnAdvanceSearch');" data-target="#ModalPopUP"><i
                                _ngcontent-efg-c1="" class="material-icons"> filter_list </i></a>
                    </div>
                </form>
            </div>
            <div class="col-sm-4">&nbsp;</div>
            <div class="col-sm-4">
                <div class="col-sm-8">&nbsp;</div>
                <div class="col-sm-4 height-34 d-flex">&nbsp;
                    <div class="form-group col-sm-6 "
                        *ngIf="this.RightsID.includes('202024001') || this.RightsID.includes('202024021') ; then ADDDiaryLink else ADDDiaryNotLink">
                    </div>
                    <ng-template #ADDDiaryLink>
                        <a href="#" data-toggle="modal" class="ml-auto"
                            (click)="OpenModal('ndc','0','Add Diary','ReturnAdvanceSearch');" data-target="#ModalPopUP">
                            <i class="material-icons" style="
                                    cursor: pointer;
                                    padding: 7px;
                                    border: 1px solid #dfdfdf;
                                    border-radius: 4px;
                                    background: linear-gradient(
                                        20.39deg,
                                        rgb(255 255 255) 15.57%,
                                        rgb(255 255 255) 100.74%
                                    ) !important;
                                    ">add</i>
                        </a>
                    </ng-template>
                    <ng-template #ADDDiaryNotLink>
                        <a href="module/0" class="ml-auto">
                            <i class="material-icons" style="
                                    cursor: pointer;
                                    padding: 7px;
                                    border: 1px solid #dfdfdf;
                                    border-radius: 4px;
                                    background: linear-gradient(
                                        20.39deg,
                                        rgb(255 255 255) 15.57%,
                                        rgb(255 255 255) 100.74%
                                    ) !important;
                                    ">add</i>
                        </a>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-12" style="margin-top: 8px;"></div>
    <div class=" col-sm-12">
        <div class=" col-sm-12 lefticonD paddingless tableHeading">View Diary/Plan</div>
        <table width="100%" class="LMtable">
            <tr>
                <th>S.No.</th>
                <th>Date</th>
                <th>In Time</th>
                <th>Ref No.</th>
                <th>Last Follow up</th>
                <th>Plan of Action</th>
                <th>Action Type</th>
                <th>Entry For</th>
                <th>Action</th>
            </tr>

            <tr *ngIf="this.MsgType == 1">
                <td colspan="80">
                    <div class="d-flex align-items-center">
                        <strong>Loading&nbsp;&nbsp;&nbsp;</strong>
                        <div class="spinner-border" role="status"></div>
                    </div>
                </td>
            </tr>
            <tr *ngIf="this.MsgType == 2">
                <td colspan="80">&nbsp;<span class="glyphicon glyphicon-info-sign"></span>&nbsp;
                    <span>{{DisplayMessage}}</span>
                </td>
            </tr>
            <tr *ngIf="this.MsgType == 3">
                <td colspan="80"><span class="Err">{{DisplayMessage}}</span>
                </td>
            </tr>
            <ng-container *ngIf="this.MsgType == 0">
                <tr *ngFor="let diary of Diary | paginate: { itemsPerPage: 10, currentPage: pageNumber }; let i=index ">
                    <td>{{(pageNumber - 1) * 10 + i +1 }}</td>
                    <td> {{diary.PlanDate|date:'dd-MMM-yyyy'}} </td>
                    <td> {{diary.PlanInTime}} </td>
                    <td *ngIf="diary.refno != null">
                        <a target="_blank"
                            routerLink="/gnotice/{{diary.NoticeType}}/{{diary.NoticeID}}">{{diary.refno}}</a>
                    </td>
                    <td *ngIf="diary.refno == null && diary.NoticePlanningID != null">
                        <a target="_blank" routerLink="/corporate-decision/{{diary.NoticePlanningID}}">Decision No -
                            {{diary.NoticePlanningID}}</a>
                    </td>
                    <td *ngIf="diary.refno == null && diary.NoticePlanningID == null">
                        &nbsp;
                    </td>
                    <td> {{diary.FUDescr}} </td>
                    <td> {{diary.PlanDescr}} </td>
                    <td> {{diary.planType}} </td>
                    <td> {{diary.UserName}} </td>
                    <td *ngIf="diary.FollowUpID != '0' ">
                        Done
                    </td>
                    <td *ngIf="diary.NoticeType == 'case' && diary.FollowUpID == '0'">
                        <a href="#/udc/{{diary.NoticeID}}/{{diary.ID}}/2"> <i
                                class="fa fa-pencil font-16 theme-icon"></i> </a>
                    </td>
                    <td *ngIf="diary.NoticeType == 'notice' && diary.FollowUpID == '0'">
                        <a href="#/udc/{{diary.NoticeID}}/{{diary.ID}}/0"> <i
                                class="fa fa-pencil font-16 theme-icon"></i> </a>
                    </td>
                    <td *ngIf="diary.refno == null && diary.NoticePlanningID == null && diary.FollowUpID == '0'">
                        <a href="#/udc/0/{{diary.ID}}/4"> <i class="fa fa-pencil font-16 theme-icon"></i> </a>
                    </td>
                    <td *ngIf="diary.refno == null && diary.NoticePlanningID != null && diary.FollowUpID == '0'">
                        <a href="#/udc/{{diary.NoticePlanningID}}/{{diary.ID}}/1"> <i
                                class="fa fa-pencil font-16 theme-icon"></i> </a>
                    </td>
                </tr>
            </ng-container>

        </table><br>
        <ng-container *ngIf="this.MsgType == 0">
            <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
        </ng-container>
    </div>


    <div><br></div>

</my-content>
<my-content placeholder="main">

</my-content> -->
}